import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Navigate, RouterProvider, createBrowserRouter, useLocation } from "react-router-dom";
import "./styles/index.css";
import { watchErrors } from "./lib/track";
import { AppShell } from "./layouts/AppShell";
import { LandingPage } from "./pages/LandingPage";
import { UasaPage } from "./pages/UasaPage";
import { UasaPaperPage } from "./pages/UasaPaper";
import { StudyBoxPage } from "./pages/StudyBoxPage";
import { CreditsPage } from "./pages/CreditsPage";
import { AnakListPage, AnakStatsPage } from "./pages/AnakPage";
import { YearPage } from "./pages/belajar/YearPage";
import { SubjectPage } from "./pages/belajar/SubjectPage";
import { UnitPage } from "./pages/belajar/UnitPage";
import { QuizPage } from "./pages/belajar/QuizPage";
import { SifirPage } from "./pages/belajar/SifirPage";
import { GamesHubPage } from "./pages/belajar/games/GamesHub";
import { PencernaanPage, SistemSuriaPage } from "./pages/belajar/games/ScienceGames";
import { FotosintesisPage } from "./pages/belajar/games/Fotosintesis";
import { JamPage, PecahanPage, WangPage } from "./pages/belajar/games/MathGames";
import { BetulSalahPage, PadanPage, QuestPage } from "./pages/belajar/games/ContentGames";
import { TadikaHomePage, TadikaLevelPage } from "./pages/belajar/tadika/TadikaPages";
import { KategoriPage } from "./pages/belajar/tadika/KategoriPage";
import { JawiPage, KiraPage, WarnaPage } from "./pages/belajar/tadika/TadikaGames";
import { AngkasaPage } from "./pages/belajar/games/Angkasa";
import { KartKuizPage } from "./pages/belajar/games/arcade/KartKuiz";
import { LariKuizPage } from "./pages/belajar/games/arcade/LariKuiz";
import { DinoKejarPage } from "./pages/belajar/games/arcade/DinoKejar";
import { JetskiKuizPage } from "./pages/belajar/games/arcade/JetskiKuiz";
import { LastikKuizPage } from "./pages/belajar/games/arcade/LastikKuiz";
import { TerbangKuizPage } from "./pages/belajar/games/arcade/TerbangKuiz";
import { TadikaGarisPage } from "./pages/belajar/tadika/TadikaGaris";
import { BelonPage, EjaPage, SainsPage, TadikaPadanPage } from "./pages/belajar/tadika/TadikaMore";
import { AffiliatePage } from "./pages/AffiliatePage";
import { AdminPage } from "./pages/AdminPage";
import { CheckoutPage } from "./pages/CheckoutPage";
import { LoginPage, LoginVerifyPage } from "./pages/LoginPage";
import { AccountPage } from "./pages/AccountPage";
import { RedeemPage } from "./pages/RedeemPage";
import { LegalPage } from "./pages/LegalPage";
import { NotFoundPage } from "./pages/NotFoundPage";

/** Old StudyBox links keep working after the rename to JomBelajar. */
function StudyboxRedirect() {
  const { pathname, search, hash } = useLocation();
  return <Navigate to={pathname.replace(/^\/studybox/, "/belajar") + search + hash} replace />;
}

const router = createBrowserRouter([
  {
    element: <AppShell />,
    errorElement: <NotFoundPage />,
    children: [
      { path: "/", element: <LandingPage /> },
      { path: "/dunia/*", element: <Navigate to="/" replace /> },
      { path: "/mockup", element: <Navigate to="/" replace /> },
      { path: "/3d-mockup", element: <Navigate to="/" replace /> },
      { path: "/uasa", element: <UasaPage /> },
      { path: "/uasa/kertas/:id", element: <UasaPaperPage /> },
      { path: "/belajar", element: <StudyBoxPage /> },
      { path: "/studybox/*", element: <StudyboxRedirect /> },
      { path: "/studybox", element: <StudyboxRedirect /> },
      { path: "/belajar/sifir", element: <SifirPage /> },
      { path: "/belajar/permainan", element: <GamesHubPage /> },
      { path: "/belajar/permainan/jam", element: <JamPage /> },
      { path: "/belajar/permainan/angkasa", element: <AngkasaPage /> },
      { path: "/belajar/permainan/kart", element: <KartKuizPage /> },
      { path: "/belajar/permainan/lari", element: <LariKuizPage /> },
      { path: "/belajar/permainan/dino", element: <DinoKejarPage /> },
      { path: "/belajar/permainan/jetski", element: <JetskiKuizPage /> },
      { path: "/belajar/permainan/lastik", element: <LastikKuizPage /> },
      { path: "/belajar/permainan/terbang", element: <TerbangKuizPage /> },
      { path: "/belajar/permainan/pecahan", element: <PecahanPage /> },
      { path: "/belajar/permainan/wang", element: <WangPage /> },
      { path: "/belajar/permainan/pengembaraan", element: <QuestPage /> },
      { path: "/belajar/permainan/padan", element: <PadanPage /> },
      { path: "/belajar/permainan/betul-salah", element: <BetulSalahPage /> },
      { path: "/belajar/permainan/pencernaan", element: <PencernaanPage /> },
      { path: "/belajar/permainan/sistem-suria", element: <SistemSuriaPage /> },
      { path: "/belajar/permainan/fotosintesis", element: <FotosintesisPage /> },
      { path: "/belajar/tadika", element: <TadikaHomePage /> },
      { path: "/belajar/tadika/kira", element: <KiraPage /> },
      { path: "/belajar/tadika/jawi", element: <JawiPage /> },
      { path: "/belajar/tadika/mewarna", element: <WarnaPage /> },
      { path: "/belajar/tadika/belon", element: <BelonPage /> },
      { path: "/belajar/tadika/sains", element: <SainsPage /> },
      { path: "/belajar/tadika/eja", element: <EjaPage /> },
      { path: "/belajar/tadika/padan", element: <TadikaPadanPage /> },
      { path: "/belajar/tadika/garis/:mode", element: <TadikaGarisPage /> },
      { path: "/belajar/tadika/kategori/:id", element: <KategoriPage /> },
      { path: "/belajar/tadika/:level", element: <TadikaLevelPage /> },
      { path: "/belajar/subjek/:versionId", element: <SubjectPage /> },
      { path: "/belajar/unit/:topicId", element: <UnitPage /> },
      { path: "/belajar/unit/:topicId/kuiz", element: <QuizPage /> },
      { path: "/belajar/:level/:year", element: <YearPage /> },
      { path: "/anak", element: <AnakListPage /> },
      { path: "/anak/:id", element: <AnakStatsPage /> },
      { path: "/affiliate", element: <AffiliatePage /> },
      { path: "/admin", element: <AdminPage /> },
      { path: "/beli", element: <CheckoutPage /> },
      { path: "/r/:code", element: <CheckoutPage /> },
      { path: "/login", element: <LoginPage /> },
      { path: "/login/verify", element: <LoginVerifyPage /> },
      { path: "/akaun", element: <AccountPage /> },
      { path: "/redeem", element: <RedeemPage /> },
      { path: "/kredit", element: <CreditsPage /> },
      { path: "/terma", element: <LegalPage page="terma" /> },
      { path: "/privasi", element: <LegalPage page="privasi" /> },
      { path: "/refund", element: <LegalPage page="refund" /> },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);

watchErrors();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);

